module.exports["duplexify"] = function() { return require("duplexify"); };
module.exports["vinyl"] = function() { return require("vinyl"); };
module.exports["vinylFs"] = function() { return require("vinyl-fs"); };
module.exports["gracefulFs"] = function() { return require("graceful-fs"); };
module.exports["inherits"] = function() { return require("inherits"); };